import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const AboutUs = () => {
    const { t } = useTranslation(['about']);
    const data = t('body');
    const getSanitizedData = () => ({
        __html: DOMPurify.sanitize(data)
      });
    
    return (
        <div 
        dangerouslySetInnerHTML={getSanitizedData()}
        />
    );
};

export { AboutUs };